<script lang="ts">
  export let id: string
  export let label: string
  export let placeholder: string = ""
  export let value: string 
  export let background = "var(--grey)"
</script>

<div>
  <label for={id}>{label}</label>
  <input type="text" id={id} bind:value={value} placeholder={placeholder} style="background-color: {background};" />
</div>

<style lang="scss">
  label {
    display: block;
    color: var(--black);
    margin-bottom: 10px;
  }

  input {
    display: block;
    box-sizing: border-box;
    width: 100%;
    border-radius: 10px;
    padding: 13px;
    border: none
  }
</style>